export default __webpack_public_path__ + "static/media/a1.8b0f2979.png";